import { render, staticRenderFns } from "./AdminTask.vue?vue&type=template&id=51f013fa"
import script from "./AdminTask.vue?vue&type=script&lang=js"
export * from "./AdminTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports